import { DATA_VIZ_BLUE_500, GRAY_300 } from '@gitlab/ui/src/tokens/build/js/tokens';
import { defaultAreaOpacity } from '@gitlab/ui/src/utils/charts/config';
import { DEFAULT_DEBOUNCE_AND_THROTTLE_MS } from '~/lib/utils/constants';

export const scatterChartLineProps = {
  default: {
    type: 'line',
    showSymbol: false,
    // By default zlevel is 2 for all series types.
    // By increasing the zlevel to 3 we make sure that the trendline gets drawn in front of the dots in the chart.
    zlevel: 3,
  },
};

export const DATA_REFETCH_DELAY = DEFAULT_DEBOUNCE_AND_THROTTLE_MS;

export const BASE_SERIES_DATA_OPTIONS = {
  showSymbol: true,
  showAllSymbol: true,
  symbolSize: 8,
  lineStyle: {
    color: DATA_VIZ_BLUE_500,
  },
  itemStyle: {
    color: DATA_VIZ_BLUE_500,
  },
};

export const DEFAULT_SERIES_DATA_OPTIONS = {
  ...BASE_SERIES_DATA_OPTIONS,
  areaStyle: {
    opacity: 0,
  },
};

export const BASE_NULL_SERIES_OPTIONS = {
  showSymbol: false,
  lineStyle: {
    type: 'dashed',
    color: GRAY_300,
  },
  itemStyle: {
    color: GRAY_300,
  },
};

export const DEFAULT_NULL_SERIES_OPTIONS = {
  ...BASE_NULL_SERIES_OPTIONS,
  areaStyle: {
    color: 'none',
  },
};

export const NULL_SERIES_ID = 'nullSeries';

export const AREA_CHART_SERIES_OPTIONS = {
  areaStyle: { opacity: defaultAreaOpacity },
  type: 'line',
};

export const STACKED_AREA_CHART_SERIES_OPTIONS = {
  stack: 'chart',
  showSymbol: true,
};

export const STACKED_AREA_CHART_NULL_SERIES_OPTIONS = {
  stack: 'null',
};

export const CONTRIBUTIONS_METRICS = {
  PUSHES: 'pushes',
  MERGE_REQUESTS: 'merge_requests',
  ISSUES: 'issues',
  CONTRIBUTIONS_BY_USER: 'contributions_by_user',
};

export const DEFAULT_RENAMED_FILTER_KEYS = {
  assigneeUsername: 'assigneeUsernames',
  'not[assigneeUsername]': 'not[assigneeUsernames]',
};
